import React from 'react';
import styles from './SubmitButton.module.scss';

const SubmitButton = (params: any) => {
  // If reCAPTCHA is enabled, use Google's button-based approach
  if (params.useRecaptcha && params.siteKey) {
    const handleClick = (e) => {
      console.log("🖱️ reCAPTCHA button clicked!");
      console.log("Button classes:", e.target.className);
      console.log("Data attributes:", {
        sitekey: e.target.getAttribute('data-sitekey'),
        callback: e.target.getAttribute('data-callback'),
        action: e.target.getAttribute('data-action')
      });

      // Check if callback function exists
      if (typeof (window as any).onRecaptchaSubmit === 'function') {
        console.log("✅ onRecaptchaSubmit callback function exists");
      } else {
        console.log("❌ onRecaptchaSubmit callback function NOT found");
      }

      params.submitFunction(e);
    };

    return (
      <button
        aria-label={"submit button to "+`${params.name}`}
        id={params.id}
        disabled={params.isDisabled}
        className={`g-recaptcha ${params.outlined ? styles.buttonOutlined : styles.button} ${styles.purple} ${params.isDisabled ? styles.disabled: ''}`}
        data-sitekey={params.siteKey}
        data-callback="onRecaptchaSubmit"
        data-action="login"
        onClick={handleClick}>
        {params.name}
      </button>
    )
  }

  // Fallback to regular button when reCAPTCHA is disabled
  return (
    <button
      aria-label={"submit button to "+`${params.name}`}
      id={params.id}
      disabled={params.isDisabled}
      className={`${params.outlined ? styles.buttonOutlined : styles.button} ${styles.purple} ${params.isDisabled ? styles.disabled: ''}`}
      onClick={params.submitFunction}>
      {params.name}
    </button>
  )
}

export default SubmitButton;